export enum ANCHORS {
  PRESCRIPTION_SUMMARY = 'PRESCRIPTION_SUMMARY',
  CHANGE_PRESCRIPTION_EMISSION_DATE = 'CHANGE_PRESCRIPTION_EMISSION_DATE',
  GAMEFICATION_BAR = 'GAMEFICATION_BAR',
  MY_CENTRAL_MODELS = 'MY_CENTRAL_MODELS',
  MY_CENTRAL_PRESCRIBER_DATA = 'MY_CENTRAL_PRESCRIBER_DATA',
  PRESCRIPTION_MEDICINES = 'PRESCRIPTION_MEDICINES',
  CHANGE_CERTIFICATE = 'CHANGE_CERTIFICATE',
  EMISSION_EMAIL = 'EMISSION_EMAIL',
  MEDICINE = 'SEARCH_MEDICINE',
  FORMULA = 'SEARCH_FORMULA',
  EXAMS = 'SEARCH_EXAM',
  MEDICAL_CERTIFICATE = 'SEARCH_MEDICAL_CERTIFICATE',
  MEDICAL_REPORT = 'SEARCH_MEDICAL_REPORT',
  MEDICAL_REFERRAL = 'SEARCH_MEDICAL_REFERRAL',
  EXAM_DETAILS = 'EXAM_DETAILS',
  MY_CENTRAL_NEWS = 'MY_CENTRAL_NEWS',
  MY_CENTRAL_OFFICE='MY_CENTRAL_OFFICE',
  EXAM_FAVORITE = 'EXAM_FAVORITE',
  CONCOMITANCE_MEDICINE = 'CONCOMITANCE_MEDICINE',
  POSOLOGY = 'POSOLOGY',
}

export interface Notifications {
  [ANCHORS.PRESCRIPTION_SUMMARY]: Notification;
  [ANCHORS.CHANGE_PRESCRIPTION_EMISSION_DATE]: Notification;
  [ANCHORS.GAMEFICATION_BAR]: Notification;
  [ANCHORS.MY_CENTRAL_MODELS]: Notification;
  [ANCHORS.MY_CENTRAL_NEWS]: Notification;
  [ANCHORS.MY_CENTRAL_OFFICE]: Notification;
  [ANCHORS.MY_CENTRAL_PRESCRIBER_DATA]: Notification;
  [ANCHORS.PRESCRIPTION_MEDICINES]: Notification;
  [ANCHORS.CHANGE_CERTIFICATE]: Notification;
  [ANCHORS.EMISSION_EMAIL]: Notification;
  [ANCHORS.MEDICINE]: Notification;
  [ANCHORS.FORMULA]: Notification;
  [ANCHORS.EXAMS]: Notification;
  [ANCHORS.MEDICAL_CERTIFICATE]: Notification;
  [ANCHORS.MEDICAL_REPORT]: Notification;
  [ANCHORS.MEDICAL_REFERRAL]: Notification;
  [ANCHORS.EXAM_DETAILS]: Notification;
  [ANCHORS.EXAM_FAVORITE]: Notification;
  [ANCHORS.CONCOMITANCE_MEDICINE]: Notification;
  [ANCHORS.POSOLOGY]: Notification;
}

export interface Notifications {
  [ANCHORS.PRESCRIPTION_SUMMARY]: Notification;
  [ANCHORS.CHANGE_PRESCRIPTION_EMISSION_DATE]: Notification;
}

export enum ANCHOR_POS {
  'LEFT' = 'LEFT',
  'RIGHT' = 'RIGHT',
  'TOP' = 'TOP',
  'BOTTOM' = 'BOTTOM',
  'TOP_LEFT' = 'TOP_LEFT',
  'TOP_RIGHT' = 'TOP_RIGHT',
  'TOP_MOBILE' = 'TOP_MOBILE',
  'BOTTOM_RIGHT' = 'BOTTOM_RIGHT',
}

export interface Notification {
  notificationId: number;
  title: string;
  body: string;
  buttonLabel: string;
  anchorName: ANCHORS;
  featureFlagKey?: string;
}
